import api from '../../services/api';

/**
 * A page of pickups for the signed-in admin.
 *
 * Distinct from the legacy `get_order_pickup/`, which answers a flat
 * `{ order_pickups: [...] }` with the whole filtered set. This one uses the
 * standard paginated envelope and adds a `summary` counted over every match,
 * not just the page.
 *
 * @param {object} params - page, page_size, start_date, end_date, state,
 *   seller, search
 */
export const getPickupsRequest = async (params) => {
  return await api.get('order_pickups/', { params });
};

/**
 * Rebuilds a pickup's label and sends it back to the print queue.
 *
 * The pickup returns with a new `print_job_id` and its state reset to
 * `pending`; the PrintNode webhook moves it forward from there.
 *
 * @param {number|string} pickupId
 */
export const reprintPickupLabelRequest = async (pickupId) => {
  return await api.post(`order_pickups/${pickupId}/reprint/`);
};
